export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="ops-page-header">
      <div>
        <h1>{title}</h1>
        {subtitle && <p className="ops-page-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="ops-page-header-actions">{actions}</div>}
    </div>
  );
}
